(function () {
    'use strict';

    angular
        .module('app')
        .controller('UploadQueueController', function ($scope, $state, $filter, $interval, cfpLoadingBar, UploadQueueService, toaster) {
            // #region Clean Up (ran when navigating away)
            var queuePollingInterval;

            $scope.$on('$destroy', function () {
                if (angular.isDefined(queuePollingInterval)) {
                    $interval.cancel(queuePollingInterval);
                    queuePollingInterval = undefined;
                }
            });

            $scope.loaderClosed = function () {
                cfpLoadingBar.complete();
            }

            $scope.loaderStart = function () {
                cfpLoadingBar.start();
            }


            // #endregion Clean Up
            $scope.queuedItemFilter = {
                userId: null
            };

            $scope.resultCount = [25, 50, 100, 250];

            $scope.historyFilter = {
                jobGuid: null,
                queueName: null,
                jobStatus: null,
                userId: null,
                dateStart: null,
                dateEnd: null,
                pageSize: 50
            };

            $scope.getUploads = function (indexToRemove) {
              /*  $interval.cancel(queuePollingInterval); //cancel first poll before starting a new every time function is ran
                UploadQueueService.getUploadQueuePageModel()
                    .then(function (pageModel) {
                        Object.assign($scope, pageModel);
                        $scope.getUploadedByFilter();
                        Object.assign($scope.historyFilter, {
                            pageNumber: 1,
                            pageSize: pageModel.historyItems.PageSize
                        });

                        queuePollingInterval = $interval(function () {
                            UploadQueueService.getQueuedUploads($scope.queuedItemFilter).then(function (result) {
                                $scope.queuedItems = result;

                                //remove from loading array
                                if (indexToRemove > -1)
                                    $scope.uploadsQueuedForCancel.splice(indexToRemove, 1);
                            });

                            $scope.searchHistory();

                        }, 5000);
                    })
                    .finally(function () {
                        cfpLoadingBar.complete();
                    });*/
            }

            $scope.getUploads();

            // #region History Search

            $scope.selectedHistoryStatusFilter = '';
            $scope.selectedHistoryUploadTypeFilter = '';
            $scope.selectedHistoryUploadedByFilter = '';
            $scope.searchHistoryIsBusy = false;

            $scope.setHistoryStatusFilter = function () {
                Object.assign($scope.historyFilter, {
                    jobStatus: $scope.selectedHistoryStatusFilter
                });

                $scope.searchHistory();
            };

            $scope.setHistoryUploadTypeFilter = function () {
                Object.assign($scope.historyFilter, {
                    queueName: $scope.selectedHistoryUploadTypeFilter
                });

                $scope.searchHistory();
            };

            $scope.setHistoryUploadedByFilter = function () {
                Object.assign($scope.historyFilter, {
                    userId: $scope.selectedHistoryUploadedByFilter
                });

                $scope.searchHistory();
            };

            $scope.setHistoryCountFilter = function () {
                $scope.searchHistory();
            };

            $scope.dateFilterFix = 0; //quick fix for bs-datepicker firing twice on change due to some crappy code injection i made to manipulate the native bs-datepicker 2 years ago
            $scope.setHistoryDateFilter = function () {
                $scope.dateFilterFix++;
                var a = $filter('date')($scope.dateStart, 'MM/dd/yyyy 00:00:00');
                var b = $filter('date')($scope.dateEnd, 'MM/dd/yyyy 23:59:59');

                if ($scope.dateFilterFix !== 2)
                    return;

                $scope.dateFilterFix = 0;
                if ((a <= b) && a && b) {
                    Object.assign($scope.historyFilter, {
                        dateStart: a,
                        dateEnd: b
                    });

                    $scope.searchHistory();
                } else {
                    //please select a start date and end date
                    //make sure the start date is less than end date
                    if (a && b && a > b) {
                        toaster.pop({
                            type: 'error',
                            title: 'Error',
                            body: 'Select a Start date that ocurrs before the End date.',
                            timeout: 5000
                        });
                    }
                }
            }

            $scope.searchHistory = function () {
                $scope.searchHistoryIsBusy = true;
                UploadQueueService.searchUploadQueueHistory($scope.historyFilter)
                    .then(function (result) {
                        $scope.historyItems = result;
                        Object.assign($scope.historyFilter, {
                            pageNumber: result.PageNumber,
                            pageSize: result.PageSize
                        });

                        $scope.getUploadedByFilter();
                    })
                    .finally(function () {
                        $scope.searchHistoryIsBusy = false;
                    });
            };

            // #endregion History

            // #region Util Methods

            /*$scope.goToJobDetail = function (jobGuid) {
                $state.go('uploadDetails', { id: jobGuid });
            };*/

            $scope.formatTimeFromNow = function (value) {
                return moment(value)
                    .local()
                    .fromNow();
            };

            // #endregion Util Methods
            $scope.getUploadDetails = function (jobGuid) {
                $scope.uploadDetails = {description:'Loading Details...'}; //reset clear this
                $scope.uploadDetailsLoading = true;
                UploadQueueService.getUploadDetailsPageModel({
                    id: jobGuid
                })
                    .then(function (pageModel) {
                        $scope.uploadDetails = pageModel;
                    })
                    .finally(function () {
                        $scope.uploadDetailsLoading = false;
                    });
            }

            $scope.uploadResume = function (jobGuid, status) {
                UploadQueueService.uploadResume(jobGuid, status)
                    .then(function (result) {
                        //remove from loading array
                        var indexToRemove = $scope.uploadsQueuedForCancel.indexOf(jobGuid);
                        if (indexToRemove > -1)
                            $scope.uploadsQueuedForCancel.splice(indexToRemove, 1);
                        
                        //update list
                        $scope.getUploads();
                        $scope.searchHistory();
                    }, function (error) {
                        console.log(error);
                    });
            }

            $scope.uploadsQueuedForCancel = [];
            $scope.uploadCancel = function (jobGuid, status) {
                var indexToRemove = $scope.uploadsQueuedForCancel.indexOf(jobGuid);
                if (indexToRemove > -1) //prevent multiple calls for the same jobGuid
                    return;
                $scope.uploadsQueuedForCancel.push(jobGuid);
                UploadQueueService.uploadCancel(jobGuid, status)
                    .then(function (result) {
                        //update list
                        $scope.getUploads(indexToRemove);
                        $scope.searchHistory();

                    }, function (error) {
                        console.log(error);
                    })
            }

            $scope.queuedForCancel = function (jobGuid) {
                if ($scope.uploadsQueuedForCancel.indexOf(jobGuid) > -1) {
                    return true;
                } else {
                    return false;
                }
            }

            $scope.getUploadedByFilter = function () {
                $scope.uploadedByOptions = []; //clear these
                angular.forEach($scope.historyItems.Results, function (k, v) {
                    if ($scope.uploadedByOptions.map(function (e) { return e.CreatedBy }).indexOf(k.CreatedBy) === -1) {
                        $scope.uploadedByOptions.push({ CreatedBy: k.CreatedBy, CreatedByName: k.CreatedByName });
                    }
                });
            }
        });
})();
